import './jquery-validation';

export default class FormValidation {
  constructor() {
    this.dom = {
      $: window.$,
      jQuery: window.$,
      $window: jQuery(window),
      $formSubmit: $('.js-form-submit'),
      $checkboxChoosedWrap: $('.checkbox-choosed-wrap'),
      $checkboxChoosed: $('.checkbox-choosed'),
      $accContentOpen: $('.accordion-trigger')
    };
    this.init();
  }

  init() {
    $.extend($.validator.messages);
    this.events();
  }

  events() {
    this.dom.$formSubmit.click((e) => {
      let $target = $(e.currentTarget);

      //$target.closest('.form').data('action', $target.data('href'));
      if ($target.data('popup')) $target.closest('form').data('popup', $target.data('popup'));
    });
  }
}